import { createContext, useContext } from 'react';
import useZoomable from '../hooks/useZoomable';

interface IZoomableContextData extends ReturnType<typeof useZoomable> {}

const ZoomableContext = createContext<IZoomableContextData>(null);

export const useZoomableContext = () => {
    const context = useContext(ZoomableContext);

    if (context == null) {
        throw new Error('ZoomableContext must be used within <Zoomable />');
    }

    return context;
};

export default ZoomableContext;
